/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTodoTemplateRequest } from '../../models/create-todo-template-request';
import { TodoTemplate } from '../../models/todo-template';

export interface CreateTodoTemplate$Params {
      body: CreateTodoTemplateRequest
}

export function createTodoTemplate(http: HttpClient, rootUrl: string, params: CreateTodoTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<TodoTemplate>> {
  const rb = new RequestBuilder(rootUrl, createTodoTemplate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TodoTemplate>;
    })
  );
}

createTodoTemplate.PATH = '/api/v1/todo_templates';
